import { convertFromRaw, convertToRaw } from '@wix/draft-js';

export const convertPostContentToContentState = (post = {}) => {
  if (!post || !post.content) {
    return post;
  }
  return {
    ...post,
    content: convertFromRaw(post.content),
  };
};

export const convertContentStateToContent = (post = {}) => {
  if (!post || !post.content) {
    return post;
  }
  return {
    ...post,
    content: convertToRaw(post.content),
  };
};
